<template>
  <div>
    <div>
      <LoaderTuin :is-loading="loader" />
    </div>
    <div class="flex">
      <ToastAlert
        :is-active="toastAlert"
        :type="typeMsg"
        :message="msg"
        @close="closeToast"
      />
    </div>
    <!-- Información general -->
    <div class="sm:w-[380px]">
      <div
        v-if="!loader"
        class="flex flex-col space-y-4"
      >
        <p class="text-lg font-medium text-black">Información general</p>
        <div class="flex flex-1 justify-center items-center">
          <div class="w-full">
            <p class="block mb-2 text-sm font-medium text-custom_gray dark:text-white">Nombre de propiedad *</p>
            <input
              v-model="property_name"
              type="text"
              placeholder="Ingresa el nombre para la propiedad"
              class="bg-white h-11 border-gray-300 text-custom_gray text-base rounded-lg focus:ring-tuin_base-0 focus:border-tuin_base-0 block w-full p-2.5"
            />
          </div>
        </div>

        <div class="flex flex-1 justify-center items-center">
          <div class="w-full">
            <p class="block mb-2 text-sm font-medium text-custom_gray dark:text-white">Tipo de propiedad *</p>
            <SelectComponent
              ref="propertyRef"
              v-model="type_property_id"
              :options="dic_properties"
              :placeholder="'Selecciona tipo de propiedad'"
              :multiple="false"
              :show-all="false"
              :width-class="'w-full'"
              :font-size="'text-base'"
              @open="closeOthers('property')"
            />
          </div>
        </div>

        <div class="flex flex-1 justify-center items-center">
          <div class="w-full">
            <p class="block mb-2 text-sm font-medium text-custom_gray dark:text-white">Tipo de operación *</p>
            <SelectComponent
              ref="movementRef"
              v-model="type_movement_id"
              :options="dic_movements"
              :placeholder="'Selecciona una opción'"
              :multiple="false"
              :show-all="false"
              :width-class="'w-full'"
              :font-size="'text-base'"
              @open="closeOthers('movement')"
            />
          </div>
        </div>

        <div class="flex flex-1 items-center">
          <div class="flex flex-col w-full">
            <!-- Etiqueta dinámica -->
            <p
              class="block mb-2 text-sm font-medium text-custom_gray dark:text-white"
            >
              {{ type_property_id === 9 ? 'Fecha de disponibilidad *' : 'Fecha de disponibilidad' }}
            </p>

            <!-- Componente DatePicker -->
            <DatePickerComponent
              v-model="date_available"
              :placeholder="'Selecciona una fecha'"
              :orientation="'top'"
            />
          </div>
        </div>
      </div>
      <!-- Fin del bloque información general -->
      <div class="hidden mt-6 flex-col-1 justify-end items-end">
        <button
          class="w-full sm:w-auto px-5 py-2.5 rounded-lg text-sm font-medium text-white bg-tuin-100 hover:bg-tuin_hover transition-colors"
          @click="save()"
        >
          Siguiente
        </button>
      </div>
    </div>
  </div>
</template>
<script setup>
import LoaderTuin from "@/commond/LoaderTuin.vue";
import ToastAlert from "@/commond/ToastAlert.vue";
import DatePickerComponent from "@/components/common/DatePickerComponent.vue";
import axios from "axios";
import SelectComponent from '@/components/common/SelectComponent.vue';
import { usePropertySync } from "@/composables/usePropertySync";


import { ref, onMounted, computed, watch, defineEmits } from "vue";
const props = defineProps({
  resp: {
    type: Object,
    required: true,
    default: () => ({ property_name: '' })
  },
  propertyId: {
    type: Number,
    required: true,
    default: 0
  },
  isAvailable: {
    type: Boolean,
    default: false
  }
});


import { useRouter } from "vue-router";
let router = useRouter();
import { useRoute } from 'vue-router';
const route = useRoute();
import { useStore } from "vuex";
let store = useStore();
let loader = ref(false);
let session = computed(() => store.getters.getUserSession);
const {
  syncWithPropiedades: syncWithPropiedadesShared,
  syncWithEasyBroker: syncWithEasyBrokerShared,
} = usePropertySync();
//import axios from "axios";

let property_name         = ref();
let type_movement_id      = ref(1);
let type_property_id      = ref("");
let date_available        = ref("");

// Definimos la variable reactiva que controla la visibilidad de la modal.
let toastAlert = ref(false);
let typeMsg = ref("");
let msg = ref("");

let dic_properties = ref([]);
let dic_movements = ref([]);

let resp_property_id = ref(0);

const movementRef  = ref(null);
const propertyRef = ref(null);
const emit = defineEmits(['triggerUpdate']);
/*
const showAdvisorsNotificationValue = computed({
  get() {
    if (type_movement_id.value === 1) return share_commission.value === 'true';
    if (type_movement_id.value === 2) return share_commission_rent.value === 'true';
    if (type_movement_id.value === 3) return share_commission.value === 'true' || share_commission_rent.value === 'true';
    return false;
  },
  set(val) {
    if (type_movement_id.value === 1) share_commission.value = val ? 'true' : 'false';
    else if (type_movement_id.value === 2) share_commission_rent.value = val ? 'true' : 'false';
    else if (type_movement_id.value === 3) {
      if (!share_commission.value || !share_commission_rent.value) {
        if (!share_commission.value) share_commission.value = val ? 'true' : 'false';
        if (!share_commission_rent.value) share_commission_rent.value = val ? 'true' : 'false';
      }
    }
  }
});*/
function closeOthers(except) {
  if (except !== 'movement') movementRef.value?.close();
  if (except !== 'property') propertyRef.value?.close();
}

function adjustTimezone(dateString) {
  if (!dateString) return '';
  const date = new Date(dateString);
  return new Date(date.getTime() + date.getTimezoneOffset() * 60000);
}

async function save() {
  let validation = await validate_form();
  if (!validation.status) {
    showToast("danger", validation.message);
    return;
  }

  let previousMovementId = null;
  if (props.resp && props.resp.type_movement_id) {
    previousMovementId = Number(props.resp.type_movement_id);
  }
  
  // Convertir el nuevo valor a número para comparación
  const newMovementId = Number(type_movement_id.value);

  // Obtener el tipo de movimiento anterior
 /*  const previousMovementId = props.resp ? props.resp.type_movement_id : null; */

  // Buscar los nombres de type_movement y type_property
  const selectedMovement = dic_movements.value.find(m => m.value === type_movement_id.value);
  const selectedProperty = dic_properties.value.find(p => p.value === type_property_id.value);

  let post_params = {
    property_name: property_name.value,
    type_movement_id: type_movement_id.value,
    type_property_id: type_property_id.value,
    type_movement: selectedMovement ? selectedMovement.name : '',
    type_property: selectedProperty ? selectedProperty.name : '',
    ...(date_available.value && {
      date_available: (() => {
        const date = new Date(date_available.value);
        const utcDate = new Date(Date.UTC(date.getFullYear(), date.getMonth(), date.getDate()));
        return utcDate.toISOString().split("T")[0];
      })(),
    }),
    broker_id: session.value.id,
  };

  let isUpdating = false;

  if (props.propertyId != 0) {
    post_params["property_id"] = props.propertyId;
    isUpdating = true;
  }

  if (resp_property_id.value != 0) {
    post_params["property_id"] = resp_property_id.value;
    isUpdating = true;
  }

  let url = `${process.env.VUE_APP_API_BASE_URL}/broker/property/${session.value.id}/save_info_general`;

  let options = {
    headers: {
      "Content-Type": "application/json",
      Authorization: `Bearer ${session.value.token_api}`,
    },
  };

  try {
    const response = await axios.post(url, post_params, options);

    if (response.status === 200) {
      showToast("success", response.data.message);
      let updatedPropertyId = response.data.resp.id;
      emit("triggerUpdate", updatedPropertyId);

      // Verificar si el tipo de movimiento cambió a 5
      const isNowAuction = newMovementId === 5;
      const wasNotAuctionBefore = previousMovementId !== 5;

      console.log("[DEBUG] Comparación numérica:");
      console.log("[DEBUG] isNowAuction (newMovementId === 5):", isNowAuction);
      console.log("[DEBUG] wasNotAuctionBefore (previousMovementId !== 5):", wasNotAuctionBefore);

      if (isUpdating && isNowAuction) {
        console.log("[DEBUG] Llamando notificaciones porque es tipo 5...");
        await callAuctionNotifications(updatedPropertyId);
      }

      router.push({ name: "propertyFormEdit", params: { id: updatedPropertyId } });
      
      // If is updating, sync with external services
      if (isUpdating && props.isAvailable) {
        await syncWithPropiedades(updatedPropertyId);
        await syncWithEasyBroker(updatedPropertyId);
      }
      return true;
    } else {
      console.log("Error en la respuesta: ", response.status);
      return false;
    }
  } catch (error) {
    console.log("Error en la solicitud:", error);
    if (error.response && error.response.status === 401) {
      store.dispatch("clearUserSession");
      router.push({ name: "login" });
    }
    return false;
  }
}
// Función para llamar a las notificaciones de remate
  async function callAuctionNotifications(propertyId) {
      try {
          const notificationUrl = `${process.env.VUE_APP_API_BASE_URL}/auction-notice/${propertyId}`;
          const slackNotificationUrl = `${process.env.VUE_APP_API_BASE_URL}/slack-auction/${propertyId}`;
          
          const options = {
              headers: {
                  "Content-Type": "application/json",
                  Authorization: `Bearer ${session.value.token_api}`,
              },
          };

          // Llamar a la notificación de Hilos
          await axios.post(notificationUrl, {}, options);
          console.log("[AUCTION NOTICE] Notificación de Hilos enviada");
          
          // Llamar a la notificación de Slack
          await axios.post(slackNotificationUrl, {}, options);
          console.log("[AUCTION NOTICE] Notificación de Slack enviada");
          
          showToast("success", "Notificaciones de remate enviadas");
          
      } catch (error) {
          console.error("[ERROR IN AUCTION NOTIFICATIONS]", error.response);
          showToast("warning", "Notificaciones de remate no enviadas");
      }
  }
async function syncWithPropiedades(propertyId) {
  return syncWithPropiedadesShared(propertyId);
}
async function syncWithEasyBroker(propertyId) {
  return syncWithEasyBrokerShared(propertyId, {
    endpoint: "editar",
    onSuccess: () => {
      showToast("success", "Propiedad sincronizada con EasyBroker");
      setTimeout(() => {
        window.location.reload();
      }, 1500);
    },
    onError: () => {
      showToast("error", "Error al sincronizar con EasyBroker");
    },
  });
}
async function closeToast() {
  toastAlert.value = false;
  typeMsg.value = "";
  msg.value = "";
}

async function showToast(type, message){
  toastAlert.value = true;
  typeMsg.value = type;
  msg.value = message;

  setTimeout(() => {
    closeToast()
  }, 3000);
}
 
async function validate_form() {
  
  if(property_name.value  == undefined || property_name.value  == ''){
    return { "status": false, "message": "El campo nombre de propiedad es obligatorio."}    
  }

  if(type_property_id.value  == undefined || type_property_id.value  == ''){
    return { "status": false, "message": "El campo tipo de propiedad es obligatorio."}    
  }

  if(type_movement_id.value  == undefined || type_movement_id.value  == ''){
    return { "status": false, "message": "El campo tipo de operación es obligatorio."}    
  }

  if(type_property_id.value === 9 && (!date_available.value)) {
    return { "status": false, "message": "El campo fecha de disponibilidad es obligatorio para este tipo de propiedad."}    
  }

  return { "status": true, "message": "Todo esta bien "}    

}

async function getDicProperties() {
  let url = `${process.env.VUE_APP_API_BASE_URL}/catalogue/type_property`;
  let options = {
    headers: {
      "Content-Type": "application/json",
    },
  };

  const response = await axios.get(url, options);

  if (response.status == 401) {
    store.dispatch("clearUserSession");
  }

  if (response.status == 200) {
    const formattedData = response.data.resp.map((item) => ({
      value: item.id,
      name: item.name,
    }));
    dic_properties.value = formattedData;
    // filteredProperties.value = response.data.resp;
  }
}

async function getDicTypeMovement() {
  let url = `${process.env.VUE_APP_API_BASE_URL}/catalogue/type_movement_property`;
  let options = {
    headers: {
      "Content-Type": "application/json",
    },
  };

  const response = await axios.get(url, options);

  if (response.status == 401) {
    store.dispatch("clearUserSession");
  }

  if (response.status == 200) {
    const formattedData = response.data.resp.map((item) => ({
      value: item.id,
      name: item.name,
    }));
    dic_movements.value = formattedData;
    // filteredProperties.value = response.data.resp;
  }
}

onMounted(async () => {
  loader.value = true;
  await getDicProperties();
  await getDicTypeMovement();
  loader.value = false;
});

watch(
  () => props.resp,
  (newVal) => {
    property_name.value = newVal ? newVal.property_name : '';
    type_movement_id.value = newVal ? newVal.type_movement_id: '';
    type_property_id.value = newVal ? newVal.type_property_id: '';
    date_available.value = newVal && newVal.date_available ? adjustTimezone(newVal.date_available) : '';
  },
  { immediate: true }
);
watch(
  () => route.params.id,
  (newId) => {
    if (newId) {
      resp_property_id.value = parseInt(newId);
    }
  },
  { immediate: true }  // Esto hace que se ejecute inmediatamente al montar el componente
);

// Exponer el método save para que pueda ser llamado desde el componente padre
defineExpose({
  save,
  callAuctionNotifications
});

</script>


<style scoped>
/* Animación personalizada */
@keyframes fade-in {
  from {
    opacity: 0;
  }
  to {
    opacity: 1;
  }
}

.animate-fade-in {
  animation: fade-in 0.5s ease-in-out;
}
</style>